import React, { useMemo } from "react";
import { useSelector } from "react-redux";
import SensitivityBadge from "../../../../components/shared/Badge/SensitivityBadge";
import { getSensitivityRows, getTotalFiles } from "../Overviewadapters";

// Push the Critical / High / Medium / Low labels to the right; the rings stay at the right edge.
const SHIFT_RIGHT = 28; // px - raise or lower to taste

function DataEstateSensitiveCard() {
  // data now comes from /dataEstate/overview (fetched once in DataEstate.jsx)
  const overview = useSelector((state) => state.dataTagReducer.dataEstateOverview);

  const data = useMemo(() => getSensitivityRows(overview), [overview]);

  const countFor = (category) =>
    Number(
      data.find((d) => d["DataTagSensitivity.category"] === category)?.[
        "DataTagSensitivity.count"
      ] || 0,
    );

  const sensitivity_count_critical = countFor("CRITICAL");
  const sensitivity_count_high = countFor("HIGH");
  const sensitivity_count_low = countFor("LOW");
  const sensitivity_count_medium = countFor("MEDIUM");
  const total_sensitivity_count = getTotalFiles(overview);

  const sensitiveFormatData = {
    sensitivity_count_critical,
    sensitivity_count_high,
    sensitivity_count_low,
    sensitivity_count_medium,
    total_sensitivity_count,
  };

  return data.length > 0 ? (
    <div style={{ paddingLeft: SHIFT_RIGHT, boxSizing: "border-box" }}>
      <SensitivityBadge
        parentprops={sensitiveFormatData}
        loc="DataTag"
        title="Sensitivity:"
      />
    </div>
  ) : (
    <div>No Data Available</div>
  );
}

export default DataEstateSensitiveCard;